export function getUrl(url?: string | null) {
  if (url?.search(/^http(s)?:\/\//) === 0) {
    return url;
  }
  return url ? `https://${url}` : undefined;
}
